import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import sendEventWrapped from '../utils/bigQuery';

class WithImpressions extends React.Component {
    constructor(props) {
        super(props);

        this.value = {
            ...props.value,
            page: {
                ..._.get(props, 'value.page', {}),
                ctx_id: props.pageCtxId || _.get(props, 'value.page.ctx_id', ''),
                element: {
                    ..._.get(props, 'value.page.element', {})
                }
            }
        };
    }

    componentDidMount() {
        if (typeof IntersectionObserver === 'undefined') {
            return;
        }

        this.observer = new IntersectionObserver(this.handleIntersection, {
            threshold: 0.5
        });

        !this.props.find
            && this.observer.observe(this.container);
    }

    componentDidUpdate() {
        const { getInnerText, find } = this.props;

        if (find) {
            const child = this.container.querySelector(find);
            if (getInnerText && child) {
                this.value.page.element.text = child.innerText;
                this.observer && this.observer.observe(child);
            }
        }
    }

    componentWillUnmount() {
        this.observer && this.observer.disconnect();
    }

    handleIntersection = (entries) => {
        entries.forEach((entry) => {
            if (entry.intersectionRatio >= 0.5) {
                sendEventWrapped(this.value);
                this.observer && this.observer.disconnect();
            }
        });
    }

    render() {
        const { element, type, value, children, find, pageCtxId, getInnerText, ...rest } = this.props; // eslint-disable-line
        const Element = element || 'div';

        return (
            <Element {...rest} ref={(el) => this.container = el}>
                {children}
            </Element>
        );
    }
}

WithImpressions.propTypes = {
    children: PropTypes.any,
    type: PropTypes.string,
    find: PropTypes.string,
    value: PropTypes.object,
    element: PropTypes.string,
    style: PropTypes.object,
    getInnerText: PropTypes.bool,
    pageCtxId: PropTypes.string
};

WithImpressions.defaultProps = {
    getInnerText: false
};

export default WithImpressions;
